import { create } from 'zustand';

/**
 * Drives the kill-switch gate screen — the reactive backstop to the client-side
 * LD UX. Opened by the 503 interceptor when the server blocks an action
 * (`MAINTENANCE` site-wide, or `FEATURE_DISABLED` for one capability), covering
 * the window where the client's flag view is stale. The server is authoritative.
 */
export type KillSwitchGateKind = 'MAINTENANCE' | 'FEATURE_DISABLED';

interface KillSwitchGateState {
  open: boolean;
  kind: KillSwitchGateKind | null;
  switchKey: string | null;
  openGate: (payload: { kind: KillSwitchGateKind; switchKey?: string | null }) => void;
  close: () => void;
}

const useKillSwitchGateStore = create<KillSwitchGateState>((set) => ({
  open: false,
  kind: null,
  switchKey: null,
  openGate: (payload) => set({ open: true, kind: payload.kind, switchKey: payload.switchKey ?? null }),
  close: () => set({ open: false, kind: null, switchKey: null }),
}));

export const useKillSwitchGateOpen = () => useKillSwitchGateStore((s) => s.open);
export const useKillSwitchGateKind = () => useKillSwitchGateStore((s) => s.kind);
export const useCloseKillSwitchGate = () => useKillSwitchGateStore((s) => s.close);

/** Non-hook accessor for the 503 interceptor (outside React). */
export const openKillSwitchGateImperative = (payload: { kind: KillSwitchGateKind; switchKey?: string | null }) =>
  useKillSwitchGateStore.getState().openGate(payload);
